import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import OopbuySpreadsheetGuide from "../pages/oopbuy-spreadsheet-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/oopbuy-spreadsheet-guide",
    element: <OopbuySpreadsheetGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;